import React from 'react';
import {
    HomeIcon,
    KeyIcon,
    ChartBarIcon,
    BriefcaseIcon,
    WrenchScrewdriverIcon
} from '@heroicons/react/24/outline';

const profiles = [
    {
        value: 'propietario',
        icon: HomeIcon,
        label: 'Soy el propietario',
        subtitle: 'Quiero saber cuánto costaría reformarla'
    },
    {
        value: 'comprador',
        icon: KeyIcon,
        label: 'Quiero comprar para vivir',
        subtitle: 'Estado y coste de reforma antes de comprar'
    },
    {
        value: 'inversor',
        icon: ChartBarIcon,
        label: 'Soy inversor',
        subtitle: 'Oportunidades de compra, reforma y rentabilidad'
    },
    {
        value: 'agente',
        icon: BriefcaseIcon,
        label: 'Soy agente inmobiliario',
        subtitle: 'Preparo un análisis para un cliente'
    },
    {
        value: 'constructor',
        icon: WrenchScrewdriverIcon,
        label: 'Soy constructor',
        subtitle: 'Quiero valorar una obra'
    }
];

const ProfileSelector = ({ onProfileSelect, selected }) => {
    return (
        <div className="space-y-3">
            {profiles.map(({ value, icon: Icon, label, subtitle }) => {
                const isSelected = selected === value;
                return (
                    <button
                        key={value}
                        type="button"
                        onClick={() => onProfileSelect(value)}
                        className={`w-full flex items-center gap-4 px-4 py-3.5 rounded-xl border-2 text-left transition-all duration-150 ${
                            isSelected
                                ? 'border-blue-500 bg-blue-50 shadow-sm'
                                : 'border-gray-200 bg-white hover:border-blue-300 hover:bg-gray-50'
                        }`}
                    >
                        <div className={`flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center ${
                            isSelected ? 'bg-blue-500 text-white' : 'bg-gray-100 text-gray-500'
                        }`}>
                            <Icon className="h-5 w-5" />
                        </div>
                        <div>
                            <p className={`font-semibold text-sm ${isSelected ? 'text-blue-800' : 'text-gray-800'}`}>
                                {label}
                            </p>
                            <p className="text-xs text-gray-500 mt-0.5">{subtitle}</p>
                        </div>
                        {isSelected && (
                            <div className="ml-auto flex-shrink-0">
                                <div className="w-5 h-5 rounded-full bg-blue-500 flex items-center justify-center">
                                    <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                    </svg>
                                </div>
                            </div>
                        )}
                    </button>
                );
            })}
        </div>
    );
};

export default ProfileSelector;
